import {
  INIT_EDD,
  INIT_SINGLE_PAGE_CHECKOUT_PAGE,
  RECALIBRATE_SECTIONS_STATES,
  SAVE_ADDRESS_FROM_MELISSA,
  SAVE_AND_CONTINUE_PAYMENT,
  CLICKED_OUTSIDE_SHIPPING,
  SAVE_AND_CONTINUE_SHIPPING,
  TOGGLE_SPC,
  UPDATE_SECTION_STATE,
  SET_CVV_MODULE_X,
  FETCH_CVV_MODULE_X,
  SET_GIFT_DETAIL_MODAL_MODULE_X,
  FETCH_GIFT_DETAIL_MODAL_MODULE_X,
  SET_CVV_VISIBILITY_ON_VIEW_MODE,
  SUBMIT_ORDER_WITH_PAYMENT,
  SET_SPC_BTN_LOADER,
  ACTIVATE_SPC_SECTION,
  SAVE_SPC_CONTACT,
  RESET_SPC_UI_STATE,
  SET_SECTION_ANCHORING,
  UPDATE_MULTIPLE_SECTION_STATES,
  SHOW_ADDRESS_VERIFICATION,
  UPDATE_SUBMIT_ORDER_BUTTON_STATE,
  ADD_EDIT_STORE_DETAILS,
  SET_SFS_ERROR,
  ADD_SFS_ITEMS_TO_SFL,
  MOVE_ITEM_TO_SFL_TOGGLE,
  REMOVE_ITEM_IN_PROGRESS,
  IS_EXPRESS_CALL_DONE,
  IS_NON_CACHED_CART_DATA_CALL_DONE,
  TRIGGER_CHECKOUT_WITH_PAYMENT,
  IS_EXTENDED_PRE_ORDER,
  SHOW_SHIPPING_METHODS_IN_COLLAPSED,
  SET_APPLE_WALLET,
  TOGGLE_VERIFY_CVV_MODAL,
  SET_SUPPRESS_CCHECK,
  SHOULD_SHOW_VERIFY_CVV_MODAL,
  SET_IS_OOS_ITEM,
} from './SinglePageCheckout.constants';

export const initSinglePageCheckout = (payload) => ({
  type: INIT_SINGLE_PAGE_CHECKOUT_PAGE,
  payload,
});

export const initEddAction = (payload) => ({
  type: INIT_EDD,
  payload,
});

export const saveContact = (payload) => ({
  type: SAVE_SPC_CONTACT,
  payload,
});

export const saveAndContinueShipping = (payload) => ({
  type: SAVE_AND_CONTINUE_SHIPPING,
  payload,
});
export const clickedOutsideShipping = (payload) => {
  return {
    type: CLICKED_OUTSIDE_SHIPPING,
    payload,
  };
};

export const saveAndContinuePayment = (payload) => ({
  type: SAVE_AND_CONTINUE_PAYMENT,
  payload,
});

export const triggerCheckoutWithPayment = (payload) => ({
  type: TRIGGER_CHECKOUT_WITH_PAYMENT,
  payload,
});

export const submitOrderWithPayment = (payload) => ({
  type: SUBMIT_ORDER_WITH_PAYMENT,
  payload,
});

export const toggleVerifyCvvModal = (payload) => ({
  type: TOGGLE_VERIFY_CVV_MODAL,
  payload,
});

export const setSuppressCCheck = (payload) => ({
  type: SET_SUPPRESS_CCHECK,
  payload,
});

export const setShouldShowVerifyCvvModal = (payload) => ({
  type: SHOULD_SHOW_VERIFY_CVV_MODAL,
  payload,
});

export const updateSectionState = (payload) => ({
  type: UPDATE_SECTION_STATE,
  payload,
});
export const setAppleWalletSetup = (payload) => ({
  type: SET_APPLE_WALLET,
  payload,
});

/**
 * Update all section states in one go
 * @param {*} payload
 * @returns Action to update all sections
 */
export const updateMultipleSectionStates = (payload) => ({
  type: UPDATE_MULTIPLE_SECTION_STATES,
  payload,
});

export const saveAddressFromMelissa = (payload) => ({
  type: SAVE_ADDRESS_FROM_MELISSA,
  payload,
});

export const toggleSPC = (payload) => ({
  type: TOGGLE_SPC,
  payload,
});

export const recalibrateSectionStates = () => ({
  type: RECALIBRATE_SECTIONS_STATES,
});

export const fetchCvvInfoModuleX = (payload) => ({
  type: FETCH_CVV_MODULE_X,
  payload,
});

export const setCvvInfoModuleX = (payload) => ({
  type: SET_CVV_MODULE_X,
  payload,
});

export const fetchGiftDetailsModalContentModuleX = (payload) => ({
  type: FETCH_GIFT_DETAIL_MODAL_MODULE_X,
  payload,
});

export const setGiftDetailsModalContentModuleX = (payload) => ({
  type: SET_GIFT_DETAIL_MODAL_MODULE_X,
  payload,
});

export const setCvvVisibilityOnViewMode = (payload) => ({
  type: SET_CVV_VISIBILITY_ON_VIEW_MODE,
  payload,
});

export const setSpcButtonLoader = (payload) => ({
  type: SET_SPC_BTN_LOADER,
  payload,
});

export const activateSpcSection = (payload) => ({
  type: ACTIVATE_SPC_SECTION,
  payload,
});

/**
 * Reset SPC UI States
 * @returns Action to reset SPC UI States
 */
export const resetSpcUIState = () => ({ type: RESET_SPC_UI_STATE });

/**
 * Set anchor on contact/shipping/payment
 * @param {*} payload
 * @returns Action to set anchor
 */
export const setSectionAnchoring = (payload) => ({
  type: SET_SECTION_ANCHORING,
  payload,
});

export const setShowAddressVerification = (payload) => ({
  type: SHOW_ADDRESS_VERIFICATION,
  payload,
});

export const updateSubmitOrderButtonState = (payload) => ({
  type: UPDATE_SUBMIT_ORDER_BUTTON_STATE,
  payload,
});

export const addEditStoreDetails = (payload) => ({
  type: ADD_EDIT_STORE_DETAILS,
  payload,
});

export const setSFSErrors = (payload) => ({
  type: SET_SFS_ERROR,
  payload,
});

export const addSFSItemsToSFL = (payload, navigation) => ({
  type: ADD_SFS_ITEMS_TO_SFL,
  payload,
  navigation,
});

export const moveItemToSFLToggle = (payload) => ({
  type: MOVE_ITEM_TO_SFL_TOGGLE,
  payload,
});

export const setRemoveItemInProgress = (payload) => ({
  type: REMOVE_ITEM_IN_PROGRESS,
  payload,
});

export const isExpressUserCallDone = (payload) => ({
  type: IS_EXPRESS_CALL_DONE,
  payload,
});

export const isNonCachedCartDataCallDone = (payload) => ({
  type: IS_NON_CACHED_CART_DATA_CALL_DONE,
  payload,
});

export const isExtendedPreOrderForSpc = (payload) => ({
  type: IS_EXTENDED_PRE_ORDER,
  payload,
});

export const showShippingMethodsInCollapsed = (payload) => ({
  type: SHOW_SHIPPING_METHODS_IN_COLLAPSED,
  payload,
});

export const setIsOosItem = (payload) => ({
  type: SET_IS_OOS_ITEM,
  payload,
});

export default {
  initSinglePageCheckout,
  initEddAction,
  saveAndContinueShipping,
  updateSectionState,
  updateMultipleSectionStates,
  saveAddressFromMelissa,
  toggleSPC,
  recalibrateSectionStates,
  setCvvInfoModuleX,
  fetchCvvInfoModuleX,
  activateSpcSection,
  resetSpcUIState,
  setSectionAnchoring,
  setShowAddressVerification,
  updateSubmitOrderButtonState,
  addEditStoreDetails,
  setSFSErrors,
  addSFSItemsToSFL,
  showShippingMethodsInCollapsed,
};
